export const GITHUB_ZEITNEXT_GET = 'GITHUB_ZEITNEXT_GET'
export const REQUEST_QUERY = 'REQUEST_QUERY'
export const GET_PHOTO_MENU = 'GET_PHOTO_MENU'
export const GET_PHOTO_WIDTH_HEIGHT = 'GET_PHOTO_WIDTH_HEIGHT'
